var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOratorioWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275.369,
    height: 275.368,
    viewBox: "0 0 275.369 275.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oratorio_white",
    d: "M106.448,259.176V170.084a8.1,8.1,0,0,1,1.877-5.184L167.19,94.257V76.941h-4.051a8.1,8.1,0,0,1,0-16.2h4.051V56.693a8.1,8.1,0,0,1,16.2,0v4.051h4.049a8.1,8.1,0,0,1,0,16.2h-4.049V94.257l44.544,53.456V64.8A8.1,8.1,0,0,1,229,60.779L261.4,4.087a8.1,8.1,0,0,1,14.063,0l32.4,56.692a8.1,8.1,0,0,1,1.068,4.018V259.175h28.347a8.1,8.1,0,0,1,0,16.2H78.1a8.1,8.1,0,0,1,0-16.2Zm80.993-44.585a12.149,12.149,0,0,0-24.3,0v44.585h24.3Zm56.692,44.585h48.595V66.948l-24.3-42.522-24.3,42.522Zm-40.5,0h24.3V173.02l-52.645-63.173L122.645,173.02v86.157h24.3V214.592a28.347,28.347,0,0,1,56.695,0ZM260.33,80.982a8.1,8.1,0,1,1,16.2,0v24.312a8.1,8.1,0,1,1-16.2,0Z",
    transform: "translate(-70.002 -0.005)",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOratorioWhite);
export default __webpack_public_path__ + "static/media/Oratorio_white.247f6b3f2c45ad9f65b378a42bf98e25.svg";
export { ForwardRef as ReactComponent };